// Avatar initials for the sidebar user menu (Design System Phase 3 §2.5).
//
//   - First letter of first name + first letter of last name.
//   - Single-word names → first two letters.
//   - No displayName → derived from the email local-part.
//   - Nothing usable → "?".
//
// Examples: "Scott Mackenroth" → "SM", "Courtney" → "CO".

function emailLocalPart(email: string | null | undefined): string {
  if (!email) return '';
  const at = email.indexOf('@');
  return at > 0 ? email.slice(0, at) : email;
}

export function avatarInitials(
  displayName?: string | null,
  email?: string | null,
): string {
  const source = (displayName ?? '').trim() || emailLocalPart(email).trim();
  if (!source) return '?';

  const tokens = source.split(/\s+/).filter(Boolean);
  if (tokens.length >= 2) {
    return (tokens[0]![0]! + tokens[tokens.length - 1]![0]!).toUpperCase();
  }
  return tokens[0]!.slice(0, 2).toUpperCase();
}
